import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export const ForgotPassword = async (email) => {
  return await axios.post(url + "forgotPassword", email);
};
